<template>
    <b-row class="igrala-background">
        <h3 v-if="title" class="igrala-desc-title">{{title}}</h3>
        <p class="igrala-desc-text"><span v-html="description"></span></p>
    </b-row>
</template>

<script>
    export default {
        name: "PmisOsnovnaVsebinaDesc",
        props: {
            title: String,
            description: String,
        }
    }
</script>

<style lang="scss" scoped>
    .igrala-background {
        background-color: $igrala-background;
        padding: 20px;
    }

    .igrala-desc-title {
        letter-spacing: 3px;
        margin-bottom: 20px;
    }

    .igrala-desc {
        margin-top: 10px;
        margin-left: 2vw;
        margin-right: 3vw;
    }

    .igrala-desc-text {
        font-size: 1.4em;
    }
</style>
